export const environment = {
  production: false,
  api: 'https://nefab.api.apontamento.acticonsultoria.com.br',
  //api: 'http://localhost:5000',
  version: '11.02.26.2'
};

